module.exports = __webpack_public_path__ + "img/QuickRecovery.a8d873af.png";